export const sajuRoutes = [];
